<template>

<div v-if="show">
<v-menu
      v-model="menupop"
      :close-on-content-click="false"
      offset-y
      max-width="290"
    >
      <template v-slot:activator="{ on, attrs }">
      
        <a class="md-font"  v-bind="attrs"  v-on="on">
          <v-icon small left color="secondary">{{icon}}</v-icon>{{title}}
        </a>

      </template>

      <v-card>
        <div class="pa-3 md-font">{{title}}</div>
        <v-card-text>
      
        <v-row no-gutters>
            <!-- <v-col cols="6">
              <v-text-field
                dense
                hide-details
                v-model="item.name"
                label="Name"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                dense
                hide-details
                  v-model="item.amount"
                type="number"
                label="Amount"
              />
            </v-col> -->
        
            <v-col cols="6"  v-for="(field,index) in fields" :key="index">
              <v-text-field
                dense
                hide-details
                v-model="field.value"
                :type="field.type"
                :label="field.label"
              />
            </v-col>
            <v-col cols="12" class="text-right mt-4">
              <v-btn text small color="info" @click="addItem()">OK</v-btn>
            </v-col>
        </v-row>
      </v-card-text>

        
      </v-card>
    </v-menu>
  </div>             
</template>

<script>
export default {
  props: {
      show:{
          type: Boolean,
          default: true
      },
      title: {
        type: String,
        default: ""
      },
      icon: {
        type: String,
        default: ""
      },
      params: {
        type: Array,
        default:()=>[]
      }

  },

  data: () => ({
    item:{},
    fields:[],
    menupop: false, //e9335e177b288c7af4af8f1225c3f938
  }),
  watch:{
    menupop (v) {
      if(v) {
       this.fields = this.params
      }
    }
  },
  methods: {
  
    addItem(){
        this.$emit('CFEvent', this.fields)
        this.menupop = false
        
    }
  }
}
</script>
